/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-12-08 16:27:14
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyWidget } from '../BsyWidget';

import './index.css'
import { BsyUtils } from '../../utils/Utils';
import tipAlert from '../../Login/BsyAlertTip/Staticize';
import BsySLoading from '../BsySLoading';
import BsyAlert from '../BsyAlert';
import { dayjsUtils } from '../../utils/dayjsUtils';


export default class BsyBatchPrintPane extends BsyWidget {
    static defaultProps = {
        appId: '',
        entryId: '',
        doPrint: !1,
        skip: 0,
        limit: 10,
        page: 0,
        records: [],
        dataList: [],
        showMode: '',
        printId: '',
        printMethod: '',
        isLoading: false,
        has_next: false,
    }
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            title: React.language("print.batch.log"),
            onClose: this._clearInternal,
        }
        this.element = React.createRef();
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.state.doPrint) {
            this.batch_print();
        } else {
            this.printtaskList();
        }
    }

    batch_print = () => {
        const { dataList, appId, entryId, authGroupId, printId, showFields, originPrint, printMethod } = this.state;
        if (dataList.length > 0) {
            this.setState({
                isLoading: true,
            })
            this.printtaskList()
            React.axios(`/data/batch_print`,
                {
                    appId: appId,
                    entryId: entryId,
                    groupId: authGroupId,
                    authGroupId: authGroupId,
                    dataList: dataList,
                    printMethod: printMethod,
                    showFields: showFields,
                    originPrint: originPrint,
                    printId: printId,
                    extDashData: this.props.extDashData,
                })
                .then((res) => {
                    this.curTask = res.data.taskId;;
                    this._addCheckInternal()
                }).catch(res => {
                    this.setState({
                        isLoading: false,
                    })
                    console.error(res)
                })
        } else {
            tipAlert({
                type: "warning",
                msg: React.language("select.data.opreate")
            })
        }


    }

    printtaskList = () => {
        const { appId, entryId, authGroupId, limit, page } = this.state;
        React.axios(`/dashboard/app/${appId}/form/${entryId}/printtask/list`,
            {
                taskIdList: this.curTask ? [this.curTask] : [],
                skip: limit * page,
                limit: limit,
                authGroupId: authGroupId,
                appId: appId,
                entryId: entryId,
                extDashData: this.props.extDashData,
            })
            .then((res) => {
                this.setState({
                    records: [...res.data.list],
                    has_next: res.data.has_next
                })
            }).catch(res => {
                console.error(res)
            })

    }


    _clearInternal = () => {
        if (this.checkTaskinterval)
            clearTimeout(this.checkTaskinterval)
    }

    _addCheckInternal = () => {
        const { appId, entryId, authGroupId, records } = this.state;
        const { extDashData } = this.props;
        let a = this;
        this.checkTaskinterval = setTimeout(function () {


            React.axios(`/dashboard/app/${appId}/form/${entryId}/printtask/list`,
                {
                    taskIdList: a.curTask ? [a.curTask] : [],
                    authGroupId: authGroupId,
                    appId: appId,
                    entryId: entryId,
                    extDashData: extDashData,
                })
                .then((res) => {
                    a._clearInternal()
                    a.setState({
                        isLoading: false,
                        records: [...res.data.list, ...records],
                        has_next: res.data.has_next
                    })
                }).catch(res => {
                    // this.setState({
                    //     isLoading: false,
                    // })
                    console.error(res)
                })

        }, 5e3)
    }

    turnPagesFirst = () =>{
        const {page} = this.state;
        if(page <= 0){
            return;
        }
        this.setState({
            page: 0
        },this.printtaskList)
    }

    turnPagesPre = () =>{
        const {page} = this.state;
        if(page <= 0){
            return;
        }
        this.setState({
            page: page - 1
        },this.printtaskList)
    }

    turnPagesNext = () =>{
        const {page, has_next} = this.state;
        if(!has_next){
            return;
        }
        this.setState({
            page: page + 1
        },this.printtaskList)
    }



    render() {
        const { records, isLoading, appId, entryId, page, has_next } = this.state;
        return (
            <div className={"bsy-batch-print-pane"} ref={this.element}>

                <div className='content-result'>
                    {
                        isLoading && <div className="pane-pack">
                            <div>{React.language('print.batch.waiting.tip')}

                            </div>
                            <div className='pack-progress'>
                                <BsySLoading></BsySLoading>
                            </div>

                        </div>
                    }
                    {
                        records.length === 0 ? <div className='empty-tip'>{React.language('print.batch.log.none')}</div>
                            :
                            <>
                                <div className='record-wrapper' style={{height: isLoading ? "calc(100% - 177px)" : ""}}>
                                    {
                                        records.map((b, index) => {
                                            let e = '';
                                            let w = '';
                                            let f = !0;
                                            let i = '';
                                            switch (b.status) {
                                                case "expired":
                                                    e = React.language('print.batch.expired.tip');
                                                    w = React.language('print.batch.expired.tip1');
                                                    f = !1;
                                                    break;
                                                case "failed":
                                                    e = React.language('print.batch.failed.tip');
                                                    w = React.language('print.batch.failed.tip1');
                                                    i = 'icon-dingding-guide-errorTip';
                                                    f = !1;
                                                    break;
                                                case "finished":
                                                    e = React.language('print.batch.finished.tip', { time: BsyUtils.date2Str(dayjsUtils.timeToTZ(b.expireTime), "yyyy-MM-dd HH:mm") });
                                                    i = 'icon-success-print';
                                                    break;
                                                case "running":
                                                    e = React.language('print.batch.running.tip');
                                                    w = React.language('print.batch.running.tip1');
                                                    f = !1;
                                                    break;
                                                default:
                                                    return '';
                                            }

                                            return <div className={"pane-record " + b.status}
                                                key={"pane-record" + index}
                                            >
                                                <div className="record-header">
                                                    <i className={i}></i>
                                                    {
                                                        e
                                                    }
                                                    {
                                                        b.status !== "running" && <div className="btn-del" onClick={() => {

                                                            BsyAlert({
                                                                title: React.language("prompt1"),
                                                                msg: React.language('print.batch.delete.tip1'),
                                                                type: "warning",
                                                                text4Ok: React.language("delete"),
                                                                OkType: "red",
                                                                text4Cancel: React.language("cancel"),
                                                                ok: () => {

                                                                    React.axios(`/dashboard/app/${appId}/form/${entryId}/printtask/delete`,
                                                                        {
                                                                            taskId: b.taskId,
                                                                            appId: appId,
                                                                            entryId: entryId,
                                                                            extDashData: this.props.extDashData,
                                                                        })
                                                                        .then((res) => {
                                                                            let newrecords = [...records];
                                                                            newrecords.splice(index, 1);
                                                                            this.setState({
                                                                                records: [...newrecords],
                                                                            })
                                                                            tipAlert({
                                                                                type: "success",
                                                                                msg: React.language("order.delete.success")
                                                                            })
                                                                        }).catch(res => {

                                                                            console.error(res)
                                                                        })
                                                                }
                                                            })
                                                        }}>
                                                            <i className="icon-bsy-iconshanchu"></i>
                                                        </div>
                                                    }

                                                </div>
                                                <div className="record-body">
                                                    <div className="left-item">
                                                        <span className="file-name">{b.files[0].name}</span>
                                                    </div>
                                                    <div className="right-item">
                                                        <div className="right-top-item">
                                                            <div className="item-detail">
                                                                <span className="label">{React.language('widget.file.size')}</span>
                                                                <span className="cont">{b.files[0].size}</span>
                                                            </div>
                                                            <div className="item-detail"><span className="cont">
                                                                <a className="file-url" target="_blank" href={f !== "running" ? b.files[0].url : ''}
                                                                    rel="noopener noreferrer" onClick={() => {
                                                                        if (!f) {
                                                                            tipAlert({
                                                                                type: "warning",
                                                                                msg: w
                                                                            })
                                                                        }
                                                                    }}>
                                                                    <i className="icon-downPDF">
                                                                    </i>
                                                                </a>
                                                            </span>
                                                            </div>
                                                        </div>
                                                        <div className="right-bottom-item">
                                                            <div className="item-detail">
                                                                <span className="label">打印时间：</span>
                                                                <span className="cont">{BsyUtils.date2Str(dayjsUtils.timeToTZ(b.createTime), "yyyy-MM-dd HH:mm")} </span>
                                                            </div>
                                                            <div className="item-detail">
                                                                <span className="label">打印人：</span>
                                                                <span className="cont">{b.print_user}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        })
                                    }
                                </div>
                                <div className="x-pagination-content">
                                    <div className="page-cont">
                                        <div className={"page-pre-first page-item" + (page <= 0 ? " disabled" : "")} onClick={this.turnPagesFirst}>
                                            <i className="icon-anglefirst"></i>
                                        </div>
                                        <div className={"page-pre page-item" + (page <= 0 ? " disabled" : "")} onClick={this.turnPagesPre}>
                                            <i className="icon-angleleft"></i>
                                        </div>
                                        <div className={"page-next page-item" + (!has_next ? " disabled" : "")} onClick={this.turnPagesNext}>
                                            <i className="icon-angleright"></i>
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                    
                </div>
                <div className='loading'>

                </div>
            </div>
        );
    }
}
